import React from "react";

export const SearchBar = ({ searchTerm, setSearchTerm, onSearchClick }) => {
  const handleKeyDown = (event) => {
    // eslint-disable-next-line eqeqeq
    if (event.key === "Enter") {
      onSearchClick();
    }
  };
  return (
    <div className="box ml-5 titles-search">
      <input
        className="input"
        type="text"
        placeholder="Search Titles..."
        value={searchTerm}
        onKeyDown={handleKeyDown}
        onChange={(event) => setSearchTerm(event.target.value)}
      />
    </div>
  );
};
